import { render, staticRenderFns } from "./CovidFilter.vue?vue&type=template&id=532483bc&"
import script from "./CovidFilter.vue?vue&type=script&lang=js&"
export * from "./CovidFilter.vue?vue&type=script&lang=js&"
import style0 from "./CovidFilter.vue?vue&type=style&index=0&id=532483bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports